import { UUIDv4 } from '../../../types';

export const CustomAttributeDataTypes = [
  'date',
  'multi_select',
  'numeric',
  'select',
  'text',
] as const;
export type CustomAttributeDataType = (typeof CustomAttributeDataTypes)[number];

export type CustomSelectAttributeValue = {
  id: UUIDv4;
  name: string;
};

export const CustomAttributesStatuses = ['active', 'inactive', 'hidden'] as const;
export type CustomAttributesStatus = (typeof CustomAttributesStatuses)[number];

export type CommonCustomAttribute<T extends CustomAttributeDataType> = {
  id: UUIDv4;
  displayName: string;
  dataType: T;
  description?: string;
  isActive: boolean;
};

export type DateCustomAttribute = CommonCustomAttribute<'date'>;
export type TextCustomAttribute = CommonCustomAttribute<'text'>;
export type NumericCustomAttribute = CommonCustomAttribute<'numeric'>;
export type SelectCustomAttribute = CommonCustomAttribute<'select'> & {
  enumValues: string[];
  values: CustomSelectAttributeValue[];
};
export type MultiSelectCustomAttribute = CommonCustomAttribute<'multi_select'> & {
  enumValues: string[];
  values: CustomSelectAttributeValue[];
};

export type CustomAttribute =
  | DateCustomAttribute
  | TextCustomAttribute
  | NumericCustomAttribute
  | SelectCustomAttribute
  | MultiSelectCustomAttribute;

export const isSelectAttribute = (
  attribute: CustomAttribute,
): attribute is SelectCustomAttribute | MultiSelectCustomAttribute =>
  attribute.dataType === 'select' || attribute.dataType === 'multi_select';

export interface CustomAttributeValue {
  /**
   *
   * @type {CustomAttributeId}
   * @memberof CustomAttributesMapInner
   */
  id: UUIDv4;
  /**
   *
   * @type {Array<CustomAttributeChosenValue>}
   * @memberof CustomAttributesMapInner
   */
  values: Array<CustomAttributeChosenValue>;
}

export type CustomAttributeChosenValue = string | null;
